import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AppHelper, AppStatic, ContentService, WindowService } from '../_core';
// import { TypeJobListingFields } from '../content-types';
import { LcpHelper } from '../_core/_helpers/lcp-helper';
import { Subject, takeUntil } from 'rxjs';


@Component({
  selector: 'lcp-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('heroMessageLine1') heroMessageLine1: ElementRef
  @ViewChild('heroMessageLine2') heroMessageLine2: ElementRef
  @ViewChild('heroMessageLine2Container') heroMessageLine2Container: ElementRef

  @ViewChild('homeServicesTabContent') homeServicesTabContent: ElementRef

  @ViewChild('clientLogoIntersection') clientLogoIntersection: ElementRef
  @ViewChild('clientLogos') clientLogos: ElementRef


  content: any
  fields: any

  bannerImage: any
  heroMessage: any
  heroMessages: any[]
  // jobListings: Entry<TypeJobListingFields>[] | undefined;
  // fields: any

  taglineUppercase: boolean = true
  taglineLowercase: boolean = false

  shouldAnimateTagline: boolean = true;
  shouldDisplayTagline: boolean[] = [true, false]
  // shouldDisplayTaglineCursor2: boolean = true

  initialTaglineIndex: number
  animationFiles: any[]
  animationData: any = {}

  animations: any
  serviceSelected: string // content.slug
  serviceActive: string

  openServicesSm: string[] = [] // ['home-services-print'] // array of slugs

  windowScrollY: any
  clientScrollX: any

  carouselArray1: any[]
  carouselArray2: any[]

  projects: any[]

  clientLogoCount = 23 // 20

  scrollArrowIcon: any
  scrollArrowIsHidden: boolean = true
  scrollArrowIsHiddenTemp: boolean = true
  removeScrollArrow: boolean = false
  // heroTextAnimationComplete = false
  heroArrowAnimationDelay: number = 1000 // in milliseconds

  scroll$: any
  scrolledAt: number // ms
  displayArrowContainer: boolean
  displayArrow: boolean
  isListeningToScroll: boolean

  destroy$: Subject<boolean> = new Subject<boolean>();
  isDestroyed = false // checked by async work (tagline animation, delays) after each await


  constructor(
    public appHelper: AppHelper,
    public cdr: ChangeDetectorRef,
    public contentService: ContentService,
    public lcpHelper: LcpHelper,
    private windowService: WindowService
  ) { }

  ngOnInit(): void {
    this.getHomepage()
    this.getScrollArrowIcon()
    // console.log('lp', LottiePlayer)
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy() {
    // if (this.scroll$) this.scroll$.unsubscribe()
    this.isDestroyed = true
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  // returns boolean for 'shouldKeepListening'
  scrollStream() {
    if (!AppStatic.isBrowser) return
    // console.log('TODO: scrollStream')

    AppStatic.delayPromise(this.heroArrowAnimationDelay).then(() => {
      // page left during the delay: destroy$ is closed, and takeUntil(destroy$) would throw ObjectUnsubscribedError
      if (this.isDestroyed) return
      this.isListeningToScroll = true
      this.displayArrow = false
      this.displayArrowContainer = true
      // // this.toggleArrow(true, Date.now(), 100)
      // setTimeout(this.toggleArrow.bind(this, true, Date.now()), 100)

      this.maybeFadeInArrow(Date.now())

      return this.windowService.scrollContainerWindow
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        // console.log('TODO: window-scroll', res, window.scrollY)
        this.scrolledAt = Date.now()
        this.toggleArrow(false, this.scrolledAt)
        setTimeout(this.toggleArrowContainer.bind(this, false, this.scrolledAt), 100)
        setTimeout(this.maybeFadeInArrow.bind(this, this.scrolledAt), 1000) // delay after scroll stopped before arrow removed
      })
    })
  }

  // display arrow container
  toggleArrowContainer(show: boolean, scrolledAt: number) {
    if (!this.isListeningToScroll) return
    // skip if removing and not most recent
    if (!show && scrolledAt != this.scrolledAt) return
    this.displayArrowContainer = !!show || window.scrollY == 0
  }
  // fade in arrow
  toggleArrow(show: boolean, scrolledAt: number) {
    if (!this.isListeningToScroll) return
    // skip if removing but not most recent
    if (!show && scrolledAt != this.scrolledAt) return
    this.displayArrow = !!show  //|| window.scrollY == 0
  }
  // fade out arrow and remove container
  maybeFadeInArrow(scrolledAt: number) {
    if (window.scrollY != 0 && scrolledAt != this.scrolledAt) return
    // if (window.scrollY != 0) return
    // console.log('fade-in', window.scUTH rollY)
    this.toggleArrowContainer(true, scrolledAt)
    setTimeout(this.toggleArrow.bind(this, true, scrolledAt), 100)
  }


  handleSelectScrollArrow(evt: any) {
    // window.scrollY = 200;
    // console.log('TODO: handleSelectScrollArrow', evt)
    // this.windowService.snapTo('window', 300)
    // const stepValue = window.innerHeight
    window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
  }

  getHomepage(){
    // this.contentService.getHomepage()
    this.contentService.getPage({'fields.slug': 'home', 'fields.version': 2 })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
       next: (content) => {
        // console.log('CONTENT', content)
        this.content = content
        this.fields = this.content.items[0].fields
        const bannerIndex = this.appHelper.getRandomInt(4)
        this.bannerImage = this.fields['banner'] && this.fields['banner'][bannerIndex] // 'https:' + this.fields['banner'][0].fields.file.url
        
        // console.log('fields', this.fields);
        this.heroMessages = this.fields['heroMessages']
        // this.getAnimationFiles()
        // console.log('hero-messages', this.fields['heroMessages']);
        this.detectChanges()

        if (!this.heroMessages) return
        // this.initialTaglineIndex = this.lcpHelper.getRandomInt(this.heroMessages.length)
        // this.animateTagline(this.heroMessages[this.initialTaglineIndex], this.heroMessageLine1)
        this.animateTaglines(this.heroMessages)
       }
   })
  }

  getScrollArrowIcon() {
    this.contentService.getMetadata({'fields.slug': 'scroll-arrow-icon' }) // { slug: 'scroll-arrow-icon' })
    .subscribe({
      next: (meta: any) => {
        try {
          // console.log('TODO: meta', meta)
          if (!meta.items[0]) return
          this.scrollArrowIcon = meta.items[0].fields.media[0]
          this.detectChanges()
        } catch {
          console.log('ERR: ')
        }
      }
    })
  }

  projectPath(project: any) {
    return AppStatic.projectPath(project) // '/work/' + project.fields['slug']
  }

  urlFromMedia(media: any) {
    return this.lcpHelper.urlFromMedia(media)
  }

  sortSequence(sequence: any[], field: string) {
    return AppStatic.sortSequence(sequence, field)
  }


  // TAGLINE ANIMATION

  async animateTaglines(heroMessages: any[]) {
    const line1 = this.heroMessageLine1.nativeElement
    const line2 = this.heroMessageLine2.nativeElement
    if (!AppStatic.isBrowser) {
      // pre-rendering: put the tagline in the html for crawlers (invisible, see .tagline-is-prerendered);
      // the browser clears it below and types it in
      line1.textContent = heroMessages[0].fields['text']
      line2.textContent = heroMessages[1].fields['text']
      line1.classList.add('tagline-is-prerendered')
      line2.classList.add('tagline-is-prerendered')
      return
    }
    line1.textContent = ''
    line2.textContent = ''
    line1.classList.remove('tagline-is-prerendered')
    line2.classList.remove('tagline-is-prerendered')

    // console.log('hero-messages', heroMessages)
    // this.heroMessageLine1
    // await this.updateIsHidden(this.heroMessageLine2, true)
    
    // this.lcpHelper.isTypingElements.push(this.heroMessageLine1.nativeElement)
    // this.lcpHelper.isTypingElements.push(this.heroMessageLine2.nativeElement)

    // the animation takes several seconds; bail out if the page was left meanwhile
    // (otherwise it keeps running on the destroyed component and ends in scrollStream, see isDestroyed)
    const params = { shouldType: this.shouldAnimateTagline }
    await this.lcpHelper.typeSentence(heroMessages[0].fields['text'], this.heroMessageLine1.nativeElement, Object.assign({}, params, { delay: 80 }))
    if (this.isDestroyed) return
    await this.updateTaglineCursor([false, true])
    await this.updateIsHidden(this.heroMessageLine2, false)
    await this.lcpHelper.typeSentence(heroMessages[1].fields['text'], this.heroMessageLine2.nativeElement,  Object.assign({}, params, { delay: 130 }))
    if (this.isDestroyed) return
    // await this.updateTaglineCursor([false, true])
    // await this.lcpHelper.waitForMs(500)
    await this.updateTaglineCursor([false, false])
    await this.highlightContent(this.heroMessageLine2, { delay: 12 })
    if (this.isDestroyed) return
    await this.lcpHelper.waitForMs(300)
    await this.toggleIsHidden(this.heroMessageLine2Container, true)
    await this.lcpHelper.waitForMs(100)
    await this.updateTaglineStyle('lowercase')
    await this.removeTaglineHighlight(this.heroMessageLine2)
    await this.toggleIsHidden(this.heroMessageLine2Container, false)
    await this.lcpHelper.waitForMs(300)
    await this.updateTaglineCursor([false, false])
    if (this.isDestroyed) return

    // this.heroTextAnimationComplete = true
    this.detectChanges()

    this.scroll$ = this.scrollStream()
  }

  // async typeSentence(sentence: any, el: ElementRef, params={}) {
  //   // @ts-ignore
  //   let delay = params['delay'] || 100
  //   const letters = sentence.split("");
  //   let i = 0;
  //   while(i < letters.length) {
  //     let randomizedDelay = Math.max(Math.random() * delay, 10);
  //     // console.log('randy', randomizedDelay)
  //     await this.lcpHelper.waitForMs(randomizedDelay);
  //     this.typeLetter(el, letters[i], params)
  //     // $(el).append(letters[i]);
  //     i++
  //   }
  //   return;
  // }

  toggleIsHidden(el: any, hidden: boolean) {
    // console.log('ttv', hidden, this.heroMessageLine2.nativeElement)
    if (hidden) return el.nativeElement.classList.add('is-hidden')
    el.nativeElement.classList.remove('is-hidden')
  }


  async updateIsHidden(el: ElementRef, isHidden = true) {
    if (!isHidden) return setTimeout(() => { el.nativeElement.classList.remove('tagline-is-hidden') }, 500)
    
    return el.nativeElement.classList.add('tagline-is-hidden')
  }
 

  // typeLetter(el: ElementRef, letter: string, params={}) {
  //   // let el = this.createElement('span', letter)
  //   if (!this.shouldAnimateTagline) return
  //   // let fadeIn = params['fade-in']
  //   let container = el.nativeElement
  //   container.insertAdjacentHTML('beforeend', '<span>' + letter + '</span>')
  //   // if (params['fade-in'])
  // }

  createElement(type: string, innerHtml='') {
    let el = document.createElement(type);
    // el.classList.add(cssClass);
    el.innerHTML = innerHtml;
    return el
  }
  
  async highlightContent(el: ElementRef, params={}) {
    if (!this.shouldAnimateTagline) return

    // const sentence = $(el).html();
    let highlightClass = "hi"
    let ne = el.nativeElement
    // console.log('chil', ne.children)
    let children = ne.children
    let arr = Array.from(children) as Array<any>;
    // @ts-ignore
    let delay = params['delay'] || 10
    let i = 0;
    let firstHighlightedIndex: number = 1000

    while(firstHighlightedIndex > 0) {
      await this.lcpHelper.waitForMs(delay);
      // arr.pop();
      firstHighlightedIndex = arr.findIndex((span:any) => {
        return span.classList.contains(highlightClass)
      })
      if (firstHighlightedIndex == -1) firstHighlightedIndex = arr.length as number

      // console.log('fhi', arr, firstHighlightedIndex, arr.length)
      let newHi = arr[firstHighlightedIndex - 1]
      if (newHi) newHi.classList.add(highlightClass)
      // console.log('new-arr', arr)
      let outerArr = arr.map((span:any) => span.outerHTML)
      let joined = outerArr.join("")
      // console.log('joined', joined, joined || "<p></p>")
      ne.innerHTML = joined || "<span> </span>";
    }
  }

  removeTaglineHighlight(el: ElementRef) {
    if (!this.shouldAnimateTagline) return

    // const sentence = $(el).html();
    let highlightClass = "hi"
    let ne = el.nativeElement
    let children = ne.children
    let arr = Array.from(children) as Array<any>
    arr.map(span => span.classList.remove(highlightClass))
    // console.log('unh-1', unHighlighted)
    let outerArr = arr.map((span:any) => {
      return span.outerHTML
    })
    let joined = outerArr.join("")
    // console.log('unh', unHighlighted, joined, joined || "<p></p>")
    ne.innerHTML = joined || "<span> </span>";
  }

  updateTaglineStyle(state: string) {
    if (!this.shouldAnimateTagline) return

    this.taglineLowercase = state == 'lowercase'
    this.taglineUppercase = state == 'uppercase'
    // console.log('update case', state)
  }

  updateTaglineCursor(data: boolean[]) {
    this.shouldDisplayTagline = data
  }

  async deleteSentence(el: ElementRef) {
    if (!this.shouldAnimateTagline) return
    let ne = el.nativeElement
    // console.log('chil', ne.children)
    let children = ne.children
    let arr = Array.from(children);
    let i = 0;
    while(arr.length > 0) {
      await this.lcpHelper.waitForMs(10);
      arr.pop();
      // console.log('new-arr', arr)
      let outerArr = arr.map((span:any) => {
        return span.outerHTML
      })
      let joined = outerArr.join("")
      // console.log('joined', joined)
      ne.innerHTML = joined;
      // $(el).html(letters.join(""));
    }
  }
  
  // waitForMs(ms: number) {
  //   return new Promise(resolve => setTimeout(resolve, ms))
  // }


  handleSelectServiceDefault(evt: any, content: any) {
    // console.log('handleSelectService--Default', evt, content, this.homeServicesTabContent)
    let serviceSelected = content.fields['slug']
    this.serviceActive = serviceSelected == this.serviceActive ? null : serviceSelected
    this.homeServicesTabContent.nativeElement.innerHTML = this.lcpHelper.htmlFromRichText(content.fields['body'])
    this.detectChanges()
    // this.homeServicesTabContent.nativeElement.
  }

  handleSelectServiceSm(evt: any, content: any) {
    // console.log('handleSelectService--Sm', evt, content, this.homeServicesTabContent)
    let serviceSelected = content.fields['slug']
    let i = this.openServicesSm.indexOf(serviceSelected)
    if (i > -1) {
      // this.openServicesSm
      this.openServicesSm.splice(i, 1)
      return 
    } else {
      this.openServicesSm.push(serviceSelected)
    }
    // console.log('openServicesSm', this.openServicesSm)

    this.serviceActive = serviceSelected == this.serviceActive ? null : serviceSelected
    this.homeServicesTabContent.nativeElement.innerHTML = this.lcpHelper.htmlFromRichText(content.fields['body'])
    this.detectChanges()
    // this.homeServicesTabContent.nativeElement.
  }

  handleCarouselInit(evt: any) {
    // console.log('TODO: handleCarouselInit', evt)
    this.detectChanges()
  }
  
  detectChanges() {
    this.cdr.detectChanges()
  }

  ///////
  // LOTTIE FUNCTIONS - SAVE for future use
  //


  // @ViewChildren('lottiePlayer') lottiePlayers: QueryList<LottiePlayer>
  // @ViewChildren('lottiePlayerContainer') lottiePlayerContainers: QueryList<LottiePlayer>
  // animationOptions: AnimationOptions = {
  //   path: '/assets/animation.json',
  // };


  // initAnimations() {
  //   // console.log('init anim', this.lottiePlayers.toArray()) 

  //   let lottieElements = document.getElementsByClassName('lottie-player')
  //   // console.log('lottie-elements', lottieElements)
  // }


  // initScrollAnimation(el: any, index: string) {
  //   // console.log('initScrollAnimation', el, this.lottiePlayers.toArray())
  //   // setTimeout(() => { el.stop() }, 2000)
  //   // console.log('tot-frames', el.getLottie().totalFrames)
  //   this.initIntersectionObserver(el, index)
  // }

  // initIntersectionObserver(el: any, index: string) {
  //   const observer = new IntersectionObserver( 
  //     ([e]) => {
  //       // let lottie = el.getLottie()
  //       // let frame = Math.floor(e.intersectionRatio * (el.getLottie().totalFrames - 1))
  //       let lottie = this.getLottieFromIndex(index)
  //       if (!lottie) return console.log('ERR: initIntersectionObserver !lottie')

  //       let frame = Math.floor(e.intersectionRatio * (this.getLottieFromIndex(index).totalFrames - 1))

  //       // DEBUGGING (keep)
  //       // if (Array.from(el.classList).indexOf('lottie-player_1_0') > -1) {
  //       //   console.log('IR:', el.id, e.intersectionRatio, frame)
  //       // }
        
  //       el.seek(frame)
  //     },

  //     // ([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1), 
  //     { rootMargin: '300px 0px -200px 0px',
  //       threshold: this.lcpHelper.percentageSequence(500) }
  //   );

  //   // console.log('scroll-inter', el)
  //   observer.observe(el)
  // }

  // getLottieFromIndex(index: string) {
  //   let className = `lottie-player_${index}`
  //   let firstElement = document.getElementsByClassName(className)[0]
  //   if (!firstElement) return
  //   let lottie = (firstElement as any).getLottie()
  //   // console.log('lpfi', index, lottie, firstElement)
  //   return lottie
  // }

  // getAnimationDataString(file: any) {
  //   let title = this.animationTitle(file)
  //   this.getAnimationData(file)
  //     .then((raw: any) => {
  //       //  console.log('raw', raw)
  //        return JSON.stringify(raw)
  //     })
  //     .then((data: any) => {
  //       // let data = require(file)
  //       let parsed = JSON.parse(data)
  //       // console.log('anim data', typeof data, title, parsed)
  //       this.animationData[title] = data
  //       return data
  //     })
  //   // this.animationData[title] = data
  //   // return data
  // }

  // animationTitle(file: any) {
  //   return file['fileName'].split(".")[0]
  // }

  // getAnimationData(file: any): Promise<any> {
  //   if (file['contentType'] != 'application/json') return Promise.resolve()

  //   let title = this.animationTitle(file)
  //   if (this.animationData[title]) return this.animationData[title]
  //   if (this.animationData[title] == false) {
  //     return new Promise(resolve => setTimeout(this.getAnimationData.bind(this, file), 1000));
  //     // return delay(1000).then(this.getAnimationData(file))
  //   }
  //   // console.log('GAD', title, file['fileName'], file)
  //   this.animationData[title] = false
  //   return fetch("https://" + file.url)
  //     .then(res => {
  //       // console.log('GAD', res.json())
  //       return res.json()
  //     })
  //     // {
  //     //   // console.log('res', res.json())
  //     //   return res.json()
  //     // })
  // }

  // animationSrc(file: any) {
  //   let src = "https://" + file.url
  //   console.log('src', src)
  //   return src
  // }
  
  // animationCreated(animationItem: AnimationItem): void {
  //   // console.log('animationCreated:', animationItem);
  //   this.animations = animationItem
  //   // animationItem.goToAndStop(3, false)
  // }

  // handleConfigReady(evt: any) {
  //   console.log('~~ config ready', evt)
  // }
  // configReady() {
  //   console.log('~~ ~~  configReady')
  // }
  // dataReady() {
  //   console.log('~~  dataReady')
  // }
  // enterFrame(evt: any) {
  //   // console.log('~~  enterFrame', evt)
  // }
  // segmentStart(evt: any) {
  //   console.log('~~  segmentStart', evt)
  // }
  // complete(evt: any) {
  //   console.log('~~  complete', evt)
  // }
  // loopComplete(evt: any) {
  //   // console.log('~~  loopComplete', evt)
  // }
  // destroy(evt: any) {
  //   console.log('~~  destroy', evt)
  // }
  // error(evt: any) {
  //   console.log('~~  error', evt)
  // }
  
  // handlePlayerReady(evt: any, index: string) {
  //   // console.log('handlePlayerReady', evt.target)
  //   this.initScrollAnimation(evt.target, index)
  //   // setTimeout(() => this.initAnimations(), 1000)
  // }



  // domLoaded() {
  //   console.log('~~  domLoaded')
  //   // this.initAnimations()
  //   setTimeout(() => this.initAnimations(), 1000)
  //   // let lottieContainers = document.getElementsByClassName('lottie-container')
  //   // console.log('lottieContainers', lottieContainers)

  //   // create({
  //   //   mode: 'scroll',
  //   //   player: '#lottie_1',
  //   //   actions: [
  //   //     {
  //   //       visibility: [0, 1],
  //   //       type: 'seek',
  //   //       frames: [0, 100],
  //   //     },
  //   //   ],
  //   // });
  // }
  // function LottieScrollTrigger(vars) {
  //   let playhead = { frame: 0 },
  //     target = gsap.utils.toArray(vars.target)[0],
  //     speeds = { slow: "+=2000", medium: "+=1000", fast: "+=500" },
  //     st = {
  //       trigger: target,
  //       pin: true,
  //       start: "top top",
  //       end: speeds[vars.speed] || "+=1000",
  //       scrub: 1,
  //     },
  //     ctx = gsap.context && gsap.context(),
  //     animation = lottie.loadAnimation({
  //       container: target,
  //       renderer: vars.renderer || "svg",
  //       loop: false,
  //       autoplay: false,
  //       path: vars.path,
  //       rendererSettings: vars.rendererSettings || {
  //         preserveAspectRatio: "xMidYMid slice",
  //       },
  //     });
  //   for (let p in vars) {
  //     // let users override the ScrollTrigger defaults
  //     st[p] = vars[p];
  //   }
  //   animation.addEventListener("DOMLoaded", function () {
  //     let createTween = function () {
  //       animation.frameTween = gsap.to(playhead, {
  //         frame: animation.totalFrames - 1,
  //         ease: "none",
  //         onUpdate: () => animation.goToAndStop(playhead.frame, true),
  //         scrollTrigger: st,
  //       });
  //       return () => animation.destroy && animation.destroy();
  //     };
  //     ctx && ctx.add ? ctx.add(createTween) : createTween();
  //     // in case there are any other ScrollTriggers on the page and the loading of this Lottie asset caused layout changes
  //     ScrollTrigger.sort();
  //     ScrollTrigger.refresh();
  //   });
  //   return animation;
  // }

  // LottieScrollTrigger({
  //   target: "#animationWindow",
  //   path: "https://assets.codepen.io/35984/tapered_hello.json",
  //   speed: "medium",
  //   scrub: 2, // seconds it takes for the playhead to "catch up"
  //   // you can also add ANY ScrollTrigger values here too, like trigger, start, end, onEnter, onLeave, onUpdate, etc. See /docs/v3/Plugins/ScrollTrigger
  // });

  // initScrollListener() {
  //   window.addEventListener(
  //     "scroll",
  //     () => this.handleScroll(),
  //     { passive: true }
  //   );
  // }

  // handleScroll() {
  //   // console.log('scroll', window.scrollY)
  //   let newWindowScrollY = window.scrollY
  //   // this.scrolledUp = newScrollY < this.scrollY
  //   let diffWindowScrollY = newWindowScrollY - this.windowScrollY
  //   window.scroll()
  //   this.windowScrollY = newWindowScrollY

  //   let el = this.clientLogos.nativeElement
  //   let scrollX = el.scrollX
  //   el.scroll(scrollX + diffWindowScrollY, 0)

  // }

  // (((media.metadata['tags']||[])[0]||{})['sys']||{})['id']
  // imgClass(media: any) {
  //   let tags = media.metadata['tags']
  //   if (!tags || tags.length == 0) return
  //   let sys = tags[0]['sys']
  //   if (!sys) return
  //   return sys['id']
  // }

  //
  // END: LOTTIE FUNCTIONS
  ///////


}
